module.exports = __webpack_public_path__ + "epdf-app/dashboard/envelope/envelope-details-2pVp3jdO.html";